
import {Options, Vue} from "vue-class-component";
import { mask } from 'maska';
// eslint-disable-next-line vue/prefer-import-from-vue
import { isString } from '@vue/shared';
@Options({
  emits: [
    'update:modelValue',
  ],
  props: {
    maska: {
      type: Object
    },
    modelValue: {
      type: String,
      default: null
    },
    customMask: {
      type: String,
    },
    isRawValue: {
      type: Boolean,
      default: true,
    },
    tokens: {
      type: Object,
      default: {
          '#': { pattern: /\d/ },
          'X': { pattern: /[\da-zA-Z]/ },
          'S': { pattern: /[a-zA-Z]/ },
          'A': { pattern: /[a-zA-Z]/, uppercase: true },
          'a': { pattern: /[a-zA-Z]/, lowercase: true },
          '!': { escape: true },
          '*': { repeat: true }
      },
    }
  },
  data: function() {
    return {
      maskedValue: undefined,
      rawValue: undefined
    }
  },
  watch: {
    modelValue(newValue: any) {
      this.applyMask(newValue);
    }
  },
  methods: {
    removeMaskChars(value: string | number): string {
      return value ? (value+"").replaceAll(/-|\(|\)|\.|_|\s/g, "") : "";
    },
    applyMask(value:string | number) {

      let unmaskedValue;
      if(this.customMask){
        if(this.customMask == 'currency') {
          if(!isString(value)) {
            value = (value as number).toFixed(2);
          }
          const currencyMask = Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' });
          unmaskedValue = (value? value+"" : "").replace(/\D+/g, "");
          let newRawValue = 0;
          if(unmaskedValue.length > 0) {
            newRawValue =  Number.parseFloat(unmaskedValue);
          }
          if(newRawValue !== this.rawValue) {
            this.rawValue = newRawValue/100;
          }
          this.maskedValue = currencyMask.format(this.rawValue);
        }
      }
      else {
        const inputMask = this.$el.dataset.mask;
        unmaskedValue = this.removeMaskChars(value) as string;
        this.maskedValue = mask(unmaskedValue, inputMask, this.tokens);
        unmaskedValue = this.removeMaskChars(this.maskedValue);
        this.rawValue = unmaskedValue;
      }
    },
    async changeText(event: any) {
      let value;
      this.applyMask(event.target.value || "", event);
      if(this.isRawValue) {
        value = this.rawValue;
      } else {
        value = this.maskedValue;
      }
      this.$emit('update:modelValue', value);
    }
  },
  mounted() {
    if(this.modelValue) {
      this.applyMask(this.modelValue);
    }
  }
})
export default class MaskedInput extends Vue {}
